interface Project {
  id: string;
  name: string;
  image: string;
  description: string;
  bg?: string;
}

const projects: Project[] = [
  {
    id: 'hindsight',
    name: 'Hindsight',
    image: '/hindsight/hero.webp',
    description: 'An interactive visualization tool for Mars Perseverance rover mission data',
  },
  {
    id: 'disha',
    name: 'Project Disha',
    image: '/disha/hero.webp',
    description: 'A field guide for highly contextualized responses to early hysterectomies among India\'s sugarcane harvesters',
  },
  {
    id: 'habitat2100',
    name: 'Habitat2100',
    image: 'habitat2100/hero.webp',
    description: 'An interactive window into the future of species habitats under climate change',
  },
  {
    id: 'rooted_in_place',
    name: 'Rooted In Place',
    image: '/rooted_in_place/hero.webp',
    description: 'A speculative experiment in co-creating the built environment with 3D-printed scaffolds and plant roots',
  },
  // {
  //   id: 'heart_hat',
  //   name: 'Heart Hat',
  //   image: 'https://placehold.co/600x400/fff700/000?text=Cards',
  // },
];

export default projects; 